var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('van-cell-group',[_c('van-cell',{attrs:{"title":_vm.$t('column.Add_item'),"is-link":""},on:{"click":_vm.addShop}}),_vm._v(" "),_c('van-cell',{attrs:{"title":_vm.$t('column.Product_list'),"is-link":""},on:{"click":_vm.shop_product_list}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5781700a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop_manage.vue
// module id = null
// module chunks = 